import React from 'react'
import './Header.css'
export default function Header(){
    return (
        <header role="banner">
           <h1 className='title'>Sleep Time Tracker</h1>
      </header>
    )
 
}